var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('e-charts',{ref:"bar",attrs:{"autoresize":"","options":_vm.bar_asig,"theme":"ovilia-green","auto-resize":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }